import { Component, EventEmitter, Input, Output } from '@angular/core';
import { User, UserManagementColumn, UsersBrands, SortState } from '../types';
import { AgGridAngular } from 'ag-grid-angular';
import { RowClickedEvent, type ColDef, SortChangedEvent } from "ag-grid-community";
import { AgTooltipCellComponent } from '../../../shared/components/ag-tooltip-cell/ag-tooltip-cell.component';
import { getManagementDateFormat } from '../../../utils/time';
import { MANAGEMENT_GRID_MODULES, MANAGEMENT_GRID_THEME, createManagementGridOptions, toSortState } from '../management-grid';

@Component({
  selector: 'app-users-table',
  imports: [AgGridAngular],
  templateUrl: './users-table.component.html',
  styleUrl: './users-table.component.scss'
})
export class UsersTableComponent {
  @Input() rows: User[] = [];
  @Output() rowClicked = new EventEmitter<User>();
  @Output() sortChanged = new EventEmitter<SortState>();

  readonly theme = MANAGEMENT_GRID_THEME;
  readonly modules = MANAGEMENT_GRID_MODULES;
  readonly gridOptions = createManagementGridOptions();
  colDefs: ColDef[] = this.getColDef();

  public onRowClicked = (event: RowClickedEvent): void => {
    this.rowClicked.emit(event.data as User);
  };

  public onSortChanged(event: SortChangedEvent): void {
    const sort = toSortState(event);
    if (sort) {
      this.sortChanged.emit(sort);
    }
  }

  private getColDef(): ColDef[] {
    return [
      {
        field: UserManagementColumn.EMAIL,
        cellRenderer: AgTooltipCellComponent,
        flex: 1.5,
      },
      {
        field: UserManagementColumn.FIRST_NAME,
        valueGetter: (params: any) => {
          return params.data[UserManagementColumn.FIRST_NAME] || '';
        }
      },
      {
        field: UserManagementColumn.LAST_NAME,
        valueGetter: (params: any) => {
          return params.data[UserManagementColumn.LAST_NAME] || '';
        }
      },
      {
        field: UserManagementColumn.ROLE,
        sortable: false,
      },
      {
        field: UserManagementColumn.CONNECTED_BRANDS,
        cellRenderer: AgTooltipCellComponent,
        valueGetter: (params: any) => {
          return params.data[UserManagementColumn.CONNECTED_BRANDS]
            .map((item: UsersBrands) => item?.name)
            .filter(Boolean)
            .join(', ');
        },
        sortable: false,
      },
      {
        field: UserManagementColumn.ACCOUNT,
        cellRenderer: AgTooltipCellComponent,
        valueGetter: (params: any) => {
          return params.data[UserManagementColumn.ACCOUNT]?.name
        },
        sortable: false,
      },
      {
        field: UserManagementColumn.CREATED_AT,
        cellRenderer: AgTooltipCellComponent,
        valueGetter: (params: any) => {
          return getManagementDateFormat(params.data[UserManagementColumn.CREATED_AT])
        }
      },
      {
        field: UserManagementColumn.LAST_LOGIN,
        cellRenderer: AgTooltipCellComponent,
        valueGetter: (params: any) => {
          return params.data[UserManagementColumn.LAST_LOGIN] ? getManagementDateFormat(params.data[UserManagementColumn.LAST_LOGIN]) : ''
        },
        sortable: false,
      },
    ];
  }
}
